// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3hv5u","left":"StickyBox_left__mi3I0","right":"StickyBox_right__3gce5"};